module.exports = __webpack_public_path__ + "img/team-stefan-kramer@2x.3c38affe.jpg";